import styled from 'styled-components'

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;
`

export const Title = styled.h1`
    font-size: 16px;
    font-weight: bold;
    color: #0b1f82;
    margin: 0;
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const Description = styled.p`
    font-size: 14px;
    font-weight: normal;
    line-height: 140%;
    color: #383838;
    transition: all 0.3s ease;
    font-family: monospace;
    white-space: pre-wrap;
`

export const ErrorText = styled.p`
    font-size: 14px;
    font-weight: normal;
    line-height: 140%;
    color: #383838;
    transition: all 0.3s ease;
    text-align: center;
    white-space: pre-wrap;
`

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`

export const ButtonWrapper = styled.div`
    transform: ${({ $expanded }) => $expanded ? 'rotate(90deg)' : 'rotate(270deg)'};
    transition: all 0.3s ease;
`

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 16px;
`

export const Badge = styled.div`
    background-color: ${({ $recommendation }) => {
        switch ($recommendation) {
            case 'suspeito':
                return '#f77b2144';
            case 'falso positivo':
                return '#0b1f8244';
            case 'suspeito crítico (em caso de bloqueio)':
                return '#ff828244';
            default:
                return 'transparent';
        }
    }};
    color: ${({ $recommendation }) => {
        switch ($recommendation) {
            case 'suspeito':
                return '#f77b21';
            case 'falso positivo':
                return '#0b1f82';
            case 'suspeito crítico (em caso de bloqueio)':
                return '#ff8282';
            default:
                return 'transparent';
        }
    }};
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 13px;
    letter-spacing: 0.5px;
    font-weight: bold;
`